import { DealSettingsView } from '@dealstack/frontend/app/pages/Project/DealDashboard/Deal.types';
import { Tree } from '@dealstack/frontend/shared/components/Tree/Tree';
import { TreeItem } from '@dealstack/frontend/shared/components/Tree/utils';
import { useTranslationAdminDashboard } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

interface Props {
	title: string;
	currentView: DealSettingsView;
	onViewChange: (view: DealSettingsView) => void;
}

export const DealSettingsSidebar = ({ title, currentView, onViewChange }: Props) => {
	const tAdminDashboard = useTranslationAdminDashboard();

	const treeItems: TreeItem<DealSettingsView>[] = [
		{
			id: DealSettingsView.General,
			name: title,
			icon: 'building-office-company-entity-line',
			selected: currentView === DealSettingsView.General,
			children: [
				{
					id: DealSettingsView.Members,
					name: tAdminDashboard('deal_settings.labels.deal_team'),
					icon: 'people-users',
					selected: currentView === DealSettingsView.Members,
				},
				{
					id: DealSettingsView.Classifiers,
					name: tAdminDashboard('deal_settings.labels.classifiers'),
					icon: 'document-v3' as PredefinedIcons,
					selected: currentView === DealSettingsView.Classifiers,
				},
				{
					id: DealSettingsView.EmailTemplates,
					name: tAdminDashboard('deal_settings.labels.email_templates', {
						defaultValue: 'Email templates',
					}),
					icon: 'mail' as PredefinedIcons,
					selected: currentView === DealSettingsView.EmailTemplates,
				},
			],
		},
	];

	const handleItemClick = (item: TreeItem<DealSettingsView>) => {
		switch (item.id) {
			case DealSettingsView.General:
				onViewChange(DealSettingsView.General);
				break;
			case DealSettingsView.Members:
				onViewChange(DealSettingsView.Members);
				break;
			case DealSettingsView.Classifiers:
				onViewChange(DealSettingsView.Classifiers);
				break;
			case DealSettingsView.EmailTemplates:
				onViewChange(DealSettingsView.EmailTemplates);
				break;
		}
	};

	return <Tree items={treeItems} onItemClick={handleItemClick} />;
};
